<template>
  <div class='xy-content-module'>
    <div class='xy-content-title xy-flex xy-between xy-center'>
      <div><!--这里是按钮 --></div>
      <div><!--这里是右侧的筛选 --></div>
    </div>
    <div class='xy-content-body'>
      <!-- 顶部名片 -->
      <div class="myCard">
        <div class="card-tit">
          <div class="my-course">
              {{ActivityCourseProjectName}}
          </div>
          <div class="time">{{xy.moment(date).format('YYYY-MM-DD')}}  {{weekNow}}</div>
        </div>
        <div class="card-main">
          <div class="today-img">
            <img v-if="result.Icon" :src="result.Icon" />
            <span v-else>{{xy.showName(result.FullName)}}</span>  
          </div>
          <div class="today-name">
            {{result.FullName}}
          </div>
          <div class="today-grade">{{result.class}}</div>
        </div>
      </div>
       <!--列表 -->
       <div v-if="list.length>0&&result.Score>0">
        <div  v-for="(item,index) in list" :key="index" class="listAll">
            <div class="listCard">
                <h3 style="display: flex;justify-content: space-between;padding-right:35px">
                  <span>{{item.ActivityCourseProjectTargetName}}</span>
                  <span v-if="item.Childrens.length === 0" style="color: #E27730;">{{item.TotalScore}}</span>
                </h3>
                <ul>
                    <li v-for="(itemLi,i) in item.Childrens" :key="i">
                        <span class="li-name">{{i+1}}. {{itemLi.ActivityCourseProjectTargetName}}</span>
                        <span class="li-score">{{itemLi.TotalScore}}</span>
                    </li>
                </ul>
            </div>
        </div>
       </div>
       <div class="listAll">
            <div class="listCard">
                <h3>活动照片</h3>
                <template 
                  slot="default"
                  class="van-cell">
                  <van-uploader 
                    v-model="fileList"
                    multiple
                    @delete="delImgae"
                    :before-read="beforeRead"
                    :max-count="9">
                    <div class="uploader-img">
                      <van-icon size="24" name="plus" color="#999" style="margin-top:20px"/>
                      <span style="margin-top:-10px; font-size: 14Px; color: #666">上传照片</span>
                    </div>
                  </van-uploader>
                </template>
                <span v-cloak style="color:#B0B0B0;font-size:14Px;margin-left: 19px;">*支持.jpg，.jpeg，.png格式，图片大小不大于5M，图片数量不大于9张。</span>
            </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
  export default {
    name: 'MyActivityDetails',
    data () {
      return {
        ActivityCourseProjectName: '',
        weekNow: ' ',
        date: new Date(),
        userName:'',
        grade:'',
        userIcon:'',
        list:[],
        result:{},
        fileList: [],
        picFileList:[],
        ServiceDoMainName:'',
        ActivityCourseProjectID:0,
        studentId:0
      }
    },
    created () {
        Toast.setDefaultOptions('loading', { duration: 0 })
        this.ServiceDoMainName = this.$store.state.apiPath;
        this.ActivityCourseProjectID = Number(this.$route.query.ActivityCourseProjectID) // 校区 id
        this.ActivityCourseProjectName = this.$route.query.ActivityCourseProjectName
        this.changeVant()
    },
    mounted () {
        this.dateNow()
        this.loadTable()
    },
    beforeUpdate () {
      this.changeVant()
    },
    watch: {
      studentId () {
        if (this.studentId > 0 && this.ActivityCourseProjectID) {
          this.GetImageByStudent()
        }
      }
    },
    methods:{
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      unloading() {
        Toast.clear()
      },
      fail(a) {
        Toast.fail({
          message: a,
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      // 上传按钮在第一位
      changeVant() {
        this.$nextTick(() => {
          let ul = document.getElementsByClassName('van-uploader__wrapper')[0]
          let fir = document.getElementsByClassName('van-uploader__input-wrapper')[0]
          ul.insertBefore(fir, ul.childNodes[0])
        })
      },
      dateNow() {
        let now = this.xy.moment(this.date).isoWeekday()
        switch (now) {
          case 1: 
            this.weekNow = '星期一'
            break
          case 2: 
            this.weekNow = '星期二'
            break
          case 3: 
            this.weekNow = '星期三'
            break
          case 4: 
            this.weekNow = '星期四'
            break
          case 5: 
            this.weekNow = '星期五'
            break
          case 6: 
            this.weekNow = '星期六'
            break
          case 7: 
            this.weekNow = '星期日'
            break
        }
      },
      //获取详情
      async loadTable () {
        this.loading()
        let res = await this.xyapi.get(`${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetMyStatisticsStudentByProjectID`, {
          ActivityCourseProjectID: this.ActivityCourseProjectID
        })
        if (res.success) {
          this.studentId = res.data.ActivityCourseStudentID
          this.list = res.data.ProjectTarget || []
          this.result = { class: res.data.StudentOrganizationName, FullName: res.data.FullName, Score: res.data.Score,Icon:res.data.Icon?res.data.Icon:'' }
        }
        this.unloading()
      },
      // 获取图片
      async GetImageByStudent () {
        this.loading()
        let res = await this.xyapi.get(`${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetImageByStudent`, {
          ActivityCourseProjectID: this.ActivityCourseProjectID,
          ActivityCourseStudentID: this.studentId
        }, true)
        this.unloading()
        this.fileList = []
        if (res.success) {
          this.imageList = res.data
          let path = `${this.xyMApi}/eva`
          for (var i = 0; i < this.imageList.length; i++) {
            this.fileList.push({
              url: path + this.imageList[i].ImageFliePath,
              ActivityCourseStudentImageID:this.imageList[i].ActivityCourseStudentImageID
            })
          }
        } else {
          this.xy.msgError(res.msg || '图片获取失败')
        }
      },
      // 上传图片前校验
      beforeRead (file) {
        var imgMasSize = 1024 * 1024 * 5;
        if (file.length + this.fileList.length > 9) {
          this.fail("最多只能上传9张图片");
          return;
        } else {
          if (typeof file === "object" && !isNaN(file.length)) {
            // 多长图片 数组
            for (var i = 0; i < file.length; i++) {
              if (
                ["jpeg", "png", "jpg"].indexOf(
                  file[i].type.split("/")[1]
                ) < 0
              ) {
                this.fail("文件类型仅支持jpeg,png,jpg");
                return;
              }
              if (file[i].size > imgMasSize) {
                this.fail("单张图片不能超过5M");
                return;
              }
            }

            var formData = new FormData();
            for (var j = 0; j < file.length; j++) {
              // name
              formData.append("name", file[j].name);
              // type
              formData.append("type", file[j].type);
              // size
              formData.append("size", file[j].size);
              // lastModifiedDate
              formData.append("lastModifiedDate", file[j].lastModifiedDate);
              // append 文件
              formData.append("File", file[j], "photo.jpg");
            }
            this.afterRead(formData);
          } else {
            // 单张图片 对象
            if (
              ["jpeg", "png", "jpg"].indexOf(file.type.split("/")[1]) < 0
            ) {
              this.fail("文件类型仅支持 jpeg,png,jpg");
              return;
            }
            if (file.size > imgMasSize) {
              this.fail("单张图片不能超过5M");
              return;
            }
            let formData = new FormData();
            // name
            formData.append("name", file.name);
            // type
            formData.append("type", file.type);
            // size
            formData.append("size", file.size);
            // lastModifiedDate
            formData.append("lastModifiedDate", file.lastModifiedDate);
            // append 文件
            formData.append("File", file, "photo.jpg");
            this.afterRead(formData);
          }
        }
      },
      // 上传图片
      async afterRead (form) {
        this.picFileList = [];
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        this.loading()
        let res = await this.xyapi.post(
          `${this.xyMApi}/eva/api/ActivityCourseProjectPad/UploadImageByStudent?ActivityCourseProjectID=${this.ActivityCourseProjectID}&ActivityCourseStudentID=${this.studentId}`,
          form,
          config
        );
        let path = `${this.xyMApi}/eva`
        if (res.success) {
          this.picFileList = res.data.result;
          for (var i = 0; i < this.picFileList.length; i++) {
            this.fileList.push({
              url: path + this.picFileList[i]
            });
          }
          this.xy.unloading()
        }
      },
      //删除图片
      async delImgae (item) {
          this.loading()
          let res = await this.xyapi.post(`${this.xyMApi}/eva/api/ActivityCourseProjectPad/DeleteImageByStudent`, {
            ActivityCourseProjectID: Number(this.ActivityCourseProjectID),
            ActivityCourseStudentID: this.studentId,
            ActivityCourseStudentImageID: item.ActivityCourseStudentImageID
          }, true)
          this.unloading()
          if (res.success) {
            this.GetImageByStudent()
          } else {
            this.xy.msgError(res.msg || '图片删除失败')
          }
        },
      }
  }
</script>
<style lang='less' scoped>
/deep/ .van-uploader__wrapper>div:nth-last-child(1) {
  margin-right: 0;
}
/deep/ .van-uploader__preview-image{
    width: 104px;
    height: 104px;
}
/deep/ .van-icon-clear:before{
    font-size: 24Px;
    background: #fff;
    border-radius: 50%;
}
/deep/ .van-uploader__preview-delete{
    top:-34px;
    right: -12px;
    background: transparent;
}
/deep/ .van-uploader__preview{
    margin: 30px 30px 0 0;
}
/deep/ .van-uploader__input-wrapper {
  margin: 10px 30px 0 0;
}
.xy-content-body {
  margin: 20px;
}
.myCard {
  width: 100%;
  height: 138px;
  background: url('./img/bluebg.png') no-repeat;
  background-size: cover;
  border-radius: 4px;
  position: relative;
  padding: 10px 10px 0 14px;
  font-size: 14px;
  .card-tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .my-course {
      display: flex;
      align-items: center;
      color: rgba(255,255,255,0.95);
      font-size: 16Px;
      font-weight: bold;
    }
    .time {
      color: rgba(255,255,255,0.85);
    }
  }
  .card-main {
    text-align: center;
    color: #fff;
    .today-img{
        span{
          display: inline-block;
          width: 50px;
          height: 50px;
          border: 1px solid #759EFF;
          border-radius: 50%;
          line-height: 50px;
          text-align: center;
          background: #4196ff;
        }
        img {
            border-radius: 50%;
            width: 50px;
            height: 50px;
            border: 2px solid #759eff;
           // margin-bottom: 8px;
        }
    }
    .today-name {
      font-size: 16px;
      margin-top: 7px;
      line-height: 22px;
      font-weight: bold;
    }
    .today-grade {
      line-height: 16px;
      font-size: 12px;
    }
  }
}
.listAll{
    width: 100%;
    height: auto;
    .listCard{
        margin-top:10px;
        background: #fff;
        border-radius: 4px;
        color: rgba(26,26,26,0.85);
        h3{
          font-size: 16Px;
          color: #1a1a1a;
          border-bottom: 1px solid #EAEAEA;
          padding: 10px;
          font-weight: bold;
        }
        ul{
            font-size: 14Px;
            li{
                display: flex;
                justify-content: space-between;
                padding: 14px 0 15px;
                margin: 0 20px 0 10px;
                padding-right: 10px;
                border-bottom: 1px dashed #eaeaea;
                .li-score{
                    color: #E27730;
                    font-weight: bold;
                }
            }
            li:nth-last-child(1) {
              border: 0;
            }
        }
    }
}
.listAll:nth-last-child(1) .listCard {
  padding-bottom: 30px;
}
.uploader-img{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 104px;
    background: #f5f5f5;
    border: 1px dashed #dddddd;
    border-radius: 4px;
    color: #666;
    margin-top:20px;
    span{
        font-size: 18Px;
    }
}
.van-cell{
  padding: 6px 19px 0;
}
.van-cell:not(:last-child):after {
  border: 0;
}
</style>
